import React, { useState, useEffect, useRef } from "react"
import BootstrapTable from 'react-bootstrap-table-next'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import apiClient from '../../../utils/api/apiClient'
import { useParams } from 'react-router-dom'
import { Button, Alert } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { getErrorMessageFromApiResponse } from "../../../utils/api/apiUtils"
import styled from 'styled-components'
import UniversalTableWrapperTest from '../../Table/UniversalTableWrapperTest'
import TableProvider, { useTableState } from '../../Table/TableProvider'

const StyledAlerts = styled.div`
  margin-top: 20px;
  `

const CostAccessRightsInner = () => {
  const { t } = useTranslation()
  const [groups, setGroups] = useState([])
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const { costCenterId } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const mountedRef = useRef(true)
  const { tableRef } = useTableState()

  //Cleanup Function
  useEffect(() => {
    return () => { mountedRef.current = false }
  }, [])

  const handleCheckedBox = (rowIndex) => {
    const newGroups = [...groups]
    newGroups[rowIndex].isAssigned = !newGroups[rowIndex].isAssigned
    setGroups(newGroups)
    setSuccess("")
  }

  const columns = [
    {
      dataField: 'isAssigned',
      text: t('costCenterAdmin:isAssigned'), //  colum header
      sort: true,
      formatter: (cell) => {
        return <input type="checkbox" checked={cell} onChange={() => { }} />  // return checkbox if the checkbox is checked use the cell true or false
      }
    },
    {
      dataField: 'group.displayName', // group.displayName
      text: t('costCenterAdmin:groupName'),
      sort: true,
    },
  ]

  useEffect(() => {
    apiClient.getJson(APIEndpoints.costCenters(costCenterId).groupAssignments)
      .then(response => {
        if (!mountedRef.current) { return null }
        setIsLoading(false)
        setGroups(response)
      })
      .catch(error => setError(getErrorMessageFromApiResponse(error)))
  }, [costCenterId])
  const handleClickSubmit = () => {

    const param = {
      "newAssignmentIds": [],
      "removedAssignmentIds": []
    }

    groups.forEach(item => {
      if (item.isAssigned) {
        param.newAssignmentIds.push(item.id)
      } else {
        param.removedAssignmentIds.push(item.id)
      }
    })

    apiClient.patchJson(APIEndpoints.costCenters(costCenterId).groupAssignments, param)
      .then(response => {
        if (!mountedRef.current) { return null }
        setSuccess(`${t('costCenterAdmin:successRight')}`)
      })
      .catch(error => setError(getErrorMessageFromApiResponse(error)))
  }

  const onRowClick = (cell, row, rowIndex) => {
    handleCheckedBox(rowIndex)
  }

  return (
    <div>
      <UniversalTableWrapperTest tableIsLoading={isLoading}>
        <BootstrapTable
          ref={tableRef}
          noDataIndication={() => <div className="no-data-placeholder">{!isLoading && t('officeAdmin:noGroupAssignments')}</div>}
          loading={isLoading}
          bootstrap4
          keyField="id"
          hover
          data={groups}
          columns={columns}
          bordered={false}
          rowEvents={{ onClick: onRowClick }}
        />
      </UniversalTableWrapperTest>
      <Button className="mb-4 mt-3" onClick={handleClickSubmit}>{t('saveButton')}</Button>
      <StyledAlerts>
        {error ?
          <Alert variant="danger"> {error} </Alert>
          : ""
        }
        {success ?
          <Alert variant="success"> {success} </Alert>
          : ""
        }
      </StyledAlerts>
    </div>
  )
}
const CostAccessRights = () => {
  return (
    <TableProvider>
      <CostAccessRightsInner />
    </TableProvider>
  )
}
export default CostAccessRights
